import { FetchResult } from '@apollo/client/link/core';
import { getGraphQLClient } from 'utilities/graphql';
import CorrectWords from 'utilities/transcript/CorrectWords.graphql';
import RevertAllCorrections from 'utilities/transcript/RevertAllCorrections.graphql';
import {
  CorrectionResult,
  RevertAllResult,
  WordCorrection,
} from 'utilities/transcript/types';
import { ApolloClient } from '@apollo/client';

export const correctWords = (
  correction: WordCorrection
): Promise<FetchResult<CorrectionResult>> => {
  const gqlClient: ApolloClient<Record<string, unknown>> = getGraphQLClient();

  return gqlClient.mutate({
    mutation: CorrectWords,
    variables: correction,
  });
};

export const revertAll = (
  videoId: string
): Promise<FetchResult<RevertAllResult>> => {
  const gqlClient: ApolloClient<Record<string, unknown>> = getGraphQLClient();

  return gqlClient.mutate({
    mutation: RevertAllCorrections,
    variables: { videoId },
  });
};
